module.exports = __webpack_public_path__ + "img/onePieceGarment.9d9c3a62.png";